import styled from 'styled-components';

import Card from '../../../components/Card/Card';

export const CardWrapper = styled(Card)`
  margin-top: 10px !important;
  max-width: 872px;
  height: 100%;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow-x: auto;
`;
